import { Navigate, useLocation } from 'react-router-dom';
import { usePermisos } from '../../contexts/PermisosContext';
import Loader from '../Loader/Loader';

const ProtectedRoute = ({ children, requiredView, requiredAction = 'ver' }) => {
  const location = useLocation();
  const { permisos, loading, tienePermiso, puedeVerRuta } = usePermisos();

  if (loading) {
    return <Loader />;
  }

  if (!permisos) {
    return <Navigate to="/" replace />;
  }

  const tieneGrupo = permisos.grupo !== null && permisos.grupo !== undefined;

  if (!tieneGrupo) {
    if (location.pathname === '/' || location.pathname === '/index') {
      return children;
    }
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (requiredView) {
    if (!tienePermiso(requiredView, requiredAction)) {
      return <Navigate to="/" replace state={{ from: location }} />;
    }
  } else {
    const ruta = location.pathname;
    
    if (ruta === '/' || ruta === '/index') {
      return children;
    }
    
    if (!puedeVerRuta(ruta)) {
      return <Navigate to="/" replace state={{ from: location }} />;
    }
  }

  return children;
};

export default ProtectedRoute;
